module.exports = __webpack_public_path__ + "static/media/nodeBlack.768b072c.svg";